
require.register("babel-runtime/node_modules/core-js/library/modules/_user-agent.js", function(exports, require, module) {
  require = __makeRelativeRequire(require, {}, "babel-runtime/node_modules/core-js");
  (function() {
    var global = require('./_global');
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';
  })();
});